import React from 'react';
import LogoGenerator from '../components/logo/LogoGenerator';

const LogoPage = () => {
  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <LogoGenerator />
    </div>
  );
};

export default LogoPage;